import { createMemo } from '@packages/react';
import { ErrorMessage as FormikErrorMessage } from 'formik';
import React from 'react';
import styled from 'styled-components';

export const StyledErrorMessage = styled.div`
    & {
        color: #ff5a5f;
        padding: 3px;
        font-size: 12px;
    }
`;

export const ErrorMessage = createMemo<{ name: string }>(
    ({ name, ...rest }) => (
        <FormikErrorMessage name={name} {...rest}>
            {(message) => <StyledErrorMessage>{message}</StyledErrorMessage>}
        </FormikErrorMessage>
    ),
    {
        displayName: 'ErrorMessage',
    },
);

export const Control = styled.div<{ margin?: string }>`
    && {
        width: 100%;
        margin: ${({ margin }) => (margin ? margin : '8px 0 4px')};

        .MuiFormControl-root {
            margin-top: 0;
        }

        .ui--outline-select {
            margin-top: 0;
        }

        .field {
            &__label {
                font-size: 14px;
                font-weight: 500;
                color: #555;
                margin-bottom: 6px;
                display: inline-block;
                padding-left: 2px;
            }
            &__holder {
                margin: 0;
            }
        }
    }
`;
